<script setup lang="ts">
  import { AccordionContent } from 'radix-vue';
  import type { AccordionContentProps } from 'radix-vue';
  import { computed } from 'vue';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<AccordionContentProps & { class?: HTMLAttributes['class'] }>();

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
  });
</script>

<template>
  <AccordionContent
    v-bind="delegatedProps"
    class="overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
  >
    <div :class="cn('pb-4 pt-0', props.class)">
      <slot />
    </div>
  </AccordionContent>
</template>
